import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import PlaceCard from "../PlaceCard";

export default function TrendingSection() {
  const [places, setPlaces] = useState([]);
  useEffect(() => { api.get("/places/trending", { params: { limit: 8 } }).then(r => setPlaces(r.data)).catch(()=>{}); }, []);
  if (places.length === 0) return null;

  return (
    <section className="px-4 sm:px-6 max-w-7xl mx-auto" data-testid="trending-section">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="uppercase-label text-[#FF6B35] flex items-center gap-1.5"><Flame size={12}/> Le moment</div>
          <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tighter text-[#1A1A1A] mt-1">
            Spots tendance
          </h2>
        </div>
        <Link to="/explore" className="text-sm font-bold text-[#FF6B35] hover:underline" data-testid="trending-see-all">Voir tout →</Link>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar -mx-4 sm:-mx-6 px-4 sm:px-6 pb-2 snap-x snap-mandatory">
        {places.map((p, i) => (
          <div key={p.id} className="snap-start shrink-0 w-[260px] sm:w-[280px]">
            <PlaceCard place={p} index={i} compact />
          </div>
        ))}
      </div>
    </section>
  );
}
